export default __webpack_public_path__ + "static/media/Monger-HUD-02.5e2c65e8.jpg";